/**
 * SidebarNavigationItem
 */
import * as React from 'react';

// Components
import SidebarNavigationItemIcon from '../SidebarNavigationItemIcon';

interface Props {
    title: string;
    iconName: string;
}

export default class SidebarNavigationItem extends React.Component<Props> {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        const { title, iconName } = this.props;

        return (
            <div className="sidebar-navigation-item">
                <SidebarNavigationItemIcon iconName={iconName} />
                <div className="sidebar-navigation-item-title">{title}</div>
            </div>
        );
    }
}
